module.exports = __webpack_public_path__ + "assets/logo.png?c3e9457835e70a11aaae9ca64d857ae0";